import {
  Grid as MuiGrid,
  Typography as MuiTypography,
  Tooltip as MuiTooltip,
} from "@mui/material";
import PropTypes from "prop-types";
import InfoCard from "./InfoCard";

const getTruncatedWords = (text?: string, limit = 8) => {
  if (!text) return "";
  const words = text.split(" ");
  return words.length > limit
    ? words.slice(0, limit).join(" ") + "..."
    : text;
};

interface Props {
  irbNumber?: string;
  nctId?: string;
  protocolNumber: string;
  title?: string;
}

const StudyMetadataCard = ({
  irbNumber,
  nctId,
  protocolNumber,
  title,
}: Props) => {
  return (
    <InfoCard>
      <MuiGrid container justifyContent="space-between" gap={1}>
        <MuiGrid item xs={1}>
          <MuiTypography variant="body2">
            <strong>IRB#:</strong> {irbNumber || "—"} &nbsp;&nbsp;
          </MuiTypography>
        </MuiGrid>
        <MuiGrid item xs={1} md>
          <MuiTypography variant="body2">
            <strong>NCT#:</strong> {nctId || "—"} &nbsp;&nbsp;
          </MuiTypography>
        </MuiGrid>
        <MuiGrid item xs={1}>
          <MuiTypography variant="body2">
            <strong>Protocol No:</strong> {protocolNumber}
          </MuiTypography>
        </MuiGrid>
      </MuiGrid>
    
      <MuiTooltip title={title || ""} placement="top">
        <MuiTypography variant="body2" color="text.secondary" mt={2}>
          {getTruncatedWords(title)}
        </MuiTypography>
      </MuiTooltip>
    </InfoCard>
  );
};

StudyMetadataCard.propTypes = {
  irbNumber: PropTypes.string.isRequired,
  nctId: PropTypes.string.isRequired,
  protocolNumber: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default StudyMetadataCard;
